module.exports = __webpack_public_path__ + "static/0-975e94e246e60a23e8a63dbab853c81b.jpg";